import { useForm, Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { CustomButton } from '../../../components/CustomButton';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeCampaignName,
  changeselectedCustomers,
  changeselectedGroupId,
  changestepcount,
  hideShareMessageDialog,
  resetBroadcast,
  setBroadcastDetails,
  setCampDetails,
  setMode,
  setScheduler,
  showShareMessageDialog,
  stepChange,
} from '../../../reducers/wca/share-message/share-message-slice';
import TemplatePreview from '../../../components/CampaignTemplatePreviewWCA';
// import TemplatePreview from '../../../components/TemplatePreviewWCA';

import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { categoryFilterOptions } from '../../../utils/templateUtils';
import { templateFilterOptions, templateFilterOptionsWCA } from '../../../utils/templateUtils';
import {
  templateTypes,
  formateMessageInput,
  validateMediaSize,
  blob,
} from '../../../utils/templateUtils';
import { useState, useRef } from 'react';
import { Text } from '../../../components/Text';
import { useEffect } from 'react';
import { Badge } from 'primereact/badge';
import CustomBreadcrumb from '../../../components/CustomBreadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getTemplates,
  getTemplatesbyId,
  getTrialTemplates,
} from '../../../reducers/templateReducer/templateActions';
import {
  getTemplates_WCA,
  getTemplateById_WCA,
} from '../../../reducers/wca/template/template-action';
import { Column } from 'primereact/column';
import CustomPaginator from '../../../components/CustomPaginator';
import { DataTable } from 'primereact/datatable';
import { addUTemplate } from '../../../reducers/templateReducer/templateSlice';
import {
  changeTemplateLimit,
  changeTemplatePage,
} from '../../../reducers/wca/template/template-slices';
import { API_SUBSCRIPTION } from '../../../api/auth.service';
import { resetAll } from '../../../reducers/productTableSlice';
import {
  getCampaignById,
  getTrialCampaignById,
  getCampaignCustomers,
  getCampaignsAnalytics,
} from '../../../reducers/campaignSlice';
import { wcaFetchCampaignById } from '../../../reducers/wca/campaign/campaign-action';
import axios from 'axios';
import { capitalizeFirstLetter } from '../../../utils/tableUtils';
import { useUtility } from '../../../context/UtilityContext';
import CampaignTemplatePreview from '../WCAMessageTemplate/CampaignTemplatePreview';
import { parseTemplateToPreview } from '../../../utils/templateUtils';
const addsteps = (name, value, url, show = true, panel = false) => {
  return { name, value, url, show, panel };
};

export const SelectTemplateWCA = ({ toast }) => {
  const [tempVariables, setTempvariables] = useState([]);
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);
  const [templateButtons, setTemplateButtons] = useState([]);
  const [subscriptionType, setSubscriptionType] = useState(null);

  const [filters1, setFilters1] = useState({
    category: { value: '' },
    templateType: { value: '' },
  });
  const { completeSteps, selectedTemplate, mode, campDetails } = useSelector(
    (state) => state.shareMessageWCA,
  );
  console.log('selectedTemplate', selectedTemplate);
  const { userSub } = useSelector((state) => state.authenticate);
  const { id } = useParams();
  const { selectedMetadataId } = useUtility();

  if (selectedTemplate) {
    var { templateType, campaignType } = selectedTemplate;
  }
  useEffect(() => {}, [selectedTemplate]);

  const defaultValues = {
    campaignName: '',
    templateType: '',
  };

  const { templateList, totalTemplatesCount, loading, pageNo, limit, selectcampaignType } =
    useSelector((state) => state.wcaMessageTemplate);

  const { campaignName } = useSelector((state) => state.shareMessage);
  const { selectedCampaign, campaignLoading, stats } = useSelector((state) => state.campaign);

  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    watch,
    reset,
    setValue,
  } = useForm(defaultValues);

  //function form get error message
  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>;
  };

  const dispatch = useDispatch();
  useEffect(() => {
    setValue('campaignName', campaignName, {
      shouldValidate: campaignName.length > 0,
    });
  }, [campaignName]);

  const steps = [];
  steps.push(
    addsteps(
      'Information',
      'info',
      `${id ? `/runcampaign/${id}` : `/runcampaign/new`}`,
      true,
      true,
    ),
  );
  steps.push(
    addsteps(
      'Edit Template',
      'info',
      `${id ? `/runcampaign/selecttemplate/${id}` : `/runcampaign/selecttemplate/new`}`,
    ),
  );
  steps.push(
    addsteps(
      'Select Product',
      'prod',
      `${id ? `/runcampaign/selectproducts/${id}` : `/runcampaign/selectproducts/new`}`,
      campaignType === 'product',
    ),
  );
  steps.push(
    addsteps(
      'Select Customer',
      'cust',
      `${id ? `/runcampaign/selectcustomer/${id}` : `/runcampaign/selectcustomer/new`}`,
    ),
  );
  steps.push(
    addsteps(
      'Schedule Campaign',
      'camp',
      `${id ? `/runcampaign/schedule/${id}` : `/runcampaign/schedule/new`}`,
    ),
  );

  useEffect(() => {
    const fetchSubscriptionType = async () => {
      try {
        const subType = userSub?.userSubType;
        setSubscriptionType(subType);
      } catch (error) {
        console.error('Error fetching subscription info:', error);
      }
    };
    fetchSubscriptionType();
  }, []);

  useEffect(() => {
    if (!id && subscriptionType) {
      try {
        dispatch(
          getTemplates_WCA({
            metadataid: selectedMetadataId,
            pageNo,
            limit,
            status: 'APPROVED',
          }),
        ).unwrap();
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    }
  }, [subscriptionType, pageNo, limit, filters1]);

  useEffect(() => {
    if (!subscriptionType) return; // Wait until subscriptionType is fetched

    if (id && completeSteps === 0) {
      const action =
        subscriptionType === 'trial'
          ? getTrialCampaignById(id)
          : wcaFetchCampaignById({ metadataId: selectedMetadataId, campaignId: id });

      dispatch(action)
        .unwrap()
        .then((details) => {
          dispatch(getTemplatesbyId(details.templateId))
            .unwrap()
            .then((x) => {
              dispatch(showShareMessageDialog({ selectedTemplate: { ...x } }));
              if (x) {
                dispatch(addUTemplate(x));
              }
              if (x?.templateType?.toUpperCase() !== 'TEXT') {
                const { mediaId } = JSON.parse(x.containerMeta);
                loadMedia(
                  `https://api.gupshup.io/wa/${x.appId}/wa/media/${mediaId}?download=false`,
                );
              }
            });

          dispatch(changeCampaignName(details.campaignName));
          setValue('campaignName', details.campaignName, {
            shouldValidate: true,
          });
          dispatch(setCampDetails(details));

          const mediaUrl = details?.variables?.mediaUrl || null;
          const skuCodes =
            details?.productItems?.length > 0 ? details.productItems.map((x) => x.SKUCode) : [];

          dispatch(
            setBroadcastDetails({
              configData: {
                ...details,
                SKUCodes: skuCodes.length > 0 ? skuCodes : [],
                id: undefined, // to avoid accidental overwrite
              },
              media: mediaUrl,
            }),
          );
        });

      dispatch(changestepcount(4));
    }
  }, [id, subscriptionType]);

  const loadMedia = (url) => {
    if (url) {
      blob(url)
        .then((blobFile) => {
          return new File([blobFile], `file.${blobFile.type.split('/')[1]}`, {
            type: blobFile.type,
          });
        })
        .then((e) => {
          const reader = new FileReader();
          const selectedFile = e;
          if (selectedFile) {
            setFile(selectedFile);
            reader.readAsDataURL(selectedFile);
            reader.onload = (readerEvent) => {
              if (selectedFile.type.includes('image')) {
                setImagePreview(readerEvent.target.result);
              } else if (selectedFile.type.includes('video')) {
                setVideoPreview(readerEvent.target.result);
              } else if (selectedFile.type.includes('pdf')) {
                setDocumentPreview(readerEvent.target.result);
              }
            };
          }
        })
        .catch((e) => {
          toast?.current?.show({
            severity: 'error',
            detail: 'Unable To Fetch File',
          });
        });
    }
  };

  // handle sumbit formdata
  const onSubmit = (data) => {
    dispatch(changeCampaignName(data.campaignName));
    if (!id) dispatch(changestepcount(1));
    navigate(`${id ? `/runcampaign/selecttemplate/${id}` : `/runcampaign/selecttemplate/new`}`);
  };

  useEffect(() => {
    if (!selectedTemplate) return;

    const parsed = parseTemplateToPreview(selectedTemplate);

    setValue('message', parsed.content);
    setValue('header', parsed.header);
    setValue('footer', parsed.footer);

    setTemplateButtons(parsed.buttons);

    // ✅ set media preview directly (NO axios needed)
    setImagePreview(parsed.media.image);
    setVideoPreview(parsed.media.video);
    setDocumentPreview(parsed.media.document);
  }, [selectedTemplate]);

  const switchform = (link) => {
    navigate(link);
  };
  const navigate = useNavigate();
  const itemslist = [{ label: 'Run Campaign', url: '' }];
  const isValidTemplate = (data) => {
    const { status } = data;
    return status == 'APPROVED';
  };
  const rowClassName = (data) => {
    return id || isValidTemplate(data) ? '' : 'not-selectable';
  };
  const isRowSelectable = (e) => {
    return id || isSelectable(e.data);
  };
  const isSelectable = (data) => {
    const { status, id } = data;
    return status === 'APPROVED' && selectedTemplate?.id !== id;
  };

  const onClearCategoryFilter = () => {
    setFilters1((prev) => {
      return {
        ...prev,
        category: { ...prev.category, value: '' },
      };
    });
  };
  const onClearTemplateTypeFilter = () => {
    setFilters1((prev) => {
      return {
        ...prev,
        templateType: { ...prev.templateType, value: '' },
      };
    });
  };

  const onApplyClick = (e) => {
    switch (e.field) {
      case 'category':
        setFilters1((prev) => {
          return {
            ...prev,
            category: { ...prev.category, value: e.constraints.value },
          };
        });
        break;
      case 'templateType':
        setFilters1((prev) => {
          return {
            ...prev,
            templateType: { ...prev.templateType, value: e.constraints.value },
          };
        });
        break;
      default:
        break;
    }
  };

  const filterItemTemplate = (option) => {
    return <span className="capitalize">{option.toLowerCase()}</span>;
  };
  const categoryFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={categoryFilterOptions}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
        }}
        itemTemplate={filterItemTemplate}
        placeholder="Select Category"
        className="p-column-filter"
      />
    );
  };
  const templateTypeFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={templateFilterOptionsWCA}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
        }}
        itemTemplate={filterItemTemplate}
        placeholder="Select type"
        className="p-column-filter"
      />
    );
  };

  const templateActiopns = (rowData) => {
    return (
      <div className="flex align-items-center gap-2">
        <CustomButton
          varient="outline"
          label={'Preview Template'}
          onClick={(e) => {
            e.preventDefault();
            onSelectProduct(rowData);
          }}
          disabled={!(id || rowData.status === 'APPROVED')}
        />
      </div>
    );
  };

  useEffect(() => {
    if (!id && selectedTemplate === null && templateList?.length > 0) {
      dispatch(
        showShareMessageDialog({
          title: '',
          selectedTemplate: templateList[0],
        }),
      );
    }
  }, [selectedTemplate, templateList]);
  const onSelectProduct = (data) => {
    dispatch(resetBroadcast());
    dispatch(
      showShareMessageDialog({
        title: '',
        selectedTemplate: data,
      }),
    );
  };
  const { navigation, setAlert } = useUtility();

  const cancelBroadcast = () => {
    dispatch(resetBroadcast());
    dispatch(resetAll());
    navigation(`${id ? `/campaigns/${id}` : `/campaigns`}`);
  };

  return (
    <div className="w-12  m-auto ">
      <div className="w-full m-auto overflow-x-auto">
        <CustomBreadcrumb home={{ label: 'Campaign', url: '/campaigns' }} itemslist={itemslist} />
      </div>
      <div className="p-3 pt-1 ">
        <div
          className="w-full m-auto flex flex-row justify-content-between align-items-center  my-2 overflow-x-auto border-round-sm "
          style={{ background: '#f2f2f2' }}
        >
          <div className="p-2 py-3 flex flex-row ">
            {steps.map((x, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-row gap-2 mr-3 cursor-pointer"
                  onClick={() => {
                    index <= completeSteps && x.show && switchform(x.url);
                  }}
                >
                  <div>
                    <Badge
                      value={index + 1}
                      style={{
                        background: index <= completeSteps ? `#1c738e` : `grey`,
                        opacity: `${x.show ? `1` : `.5`}`,
                      }}
                    />
                  </div>
                  <div
                    className={`white-space-nowrap  ${
                      x.panel ? `border-none border-bottom-1 border-solid` : ``
                    }`}
                    style={{ borderColor: '#1c738e' }}
                  >
                    {x.name}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-row gap-2 align-items-center px-2">
            <div className="font-medium text-sm cursor-pointer" onClick={cancelBroadcast}>
              Cancel
            </div>
            <div>
              <CustomButton
                varient="plain-button w-full"
                type="reset"
                onClick={() => {
                  dispatch(resetBroadcast());
                  navigate(`${id ? `/campaigns/${id}` : `/campaigns`}`);
                }}
                label={'Back'}
              />
            </div>
            <div>
              <CustomButton
                varient="filled w-full"
                type="submit"
                onClick={handleSubmit(onSubmit)}
                label={<span>Save&nbsp;&&nbsp;Continue</span>}
                disabled={!(isValid && selectedTemplate)}
              />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-wrap pt-3">
          <div className="flex flex-column w-8 flex-grow-1 lg:flex-grow-0 xl:flex-grow-0 justify-content-between">
            <form className="p-fluid w-full">
              <div className="field">
                <label htmlFor="campaignName">Campaign Name111 *</label>
                <Controller
                  name="campaignName"
                  control={control}
                  rules={{
                    required: 'Campaign name is required.',
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      maxLength={50}
                      value={field.value}
                      className={classNames({
                        'p-invalid': fieldState.invalid,
                      })}
                      placeholder="Enter campaign name"
                      {...field}
                      onChange={(e) => {
                        setAlert(true);
                        field.onChange(capitalizeFirstLetter(e.target.value));
                      }}
                    />
                  )}
                />
                {getFormErrorMessage('campaignName')}
              </div>
              <DataTable
                value={id ? [selectedTemplate] : templateList}
                dataKey="id"
                // className="skalebot-table"
                rowClassName={rowClassName}
                selection={selectedTemplate}
                onSelectionChange={(e) => {
                  setAlert(true);
                  !id && onSelectProduct(e.value);
                }}
                isDataSelectable={isRowSelectable}
                filters={filters1}
                filterDisplay="menu"
                globalFilterFields={['category', 'templateType']}
                removableSort
              >
                <Column
                  selectionMode="single"
                  headerStyle={{ width: '3rem' }}
                  header={`Select`}
                  exportable={false}
                ></Column>
                <Column
                  field="name"
                  header="Name"
                  sortable
                  className="capitalize text-sm font-normal"
                  style={{ height: '50px' }}
                />
                <Column
                  field="category"
                  header="Category"
                  filter
                  className="text-sm font-normal"
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={categoryFilterTemplate}
                  onFilterApplyClick={(e) => onApplyClick(e)}
                  onFilterClear={onClearCategoryFilter}
                  body={(rowData) => (
                    <Text cust="capitalize">{rowData?.category?.toLowerCase()}</Text>
                  )}
                />
                {/* <Column
                  field="templateType"
                  header="Template Type"
                  filter
                  className="text-sm font-normal"
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={templateTypeFilterTemplate}
                  onFilterApplyClick={(e) => onApplyClick(e)}
                  onFilterClear={onClearTemplateTypeFilter}
                  body={(rowData) => (
                    <Text cust="capitalize">
                      {rowData?.components[0]?.format
                        ? rowData?.components[0]?.format?.toLowerCase()
                        : '-'}
                    </Text>
                  )}
                /> */}
                <Column
                  field="status"
                  header="Status"
                  className="text-sm font-normal"
                  body={(rowData) => (
                    <Text cust="capitalize">{rowData?.status?.toLowerCase()}</Text>
                  )}
                />
              </DataTable>
              <div className="flex flex-row justify-content-end mb-6">
                {!id && (
                  <CustomPaginator
                    page={pageNo}
                    limit={limit}
                    totalRecords={totalTemplatesCount}
                    changePage={changeTemplatePage}
                    changelimit={changeTemplateLimit}
                  />
                )}
              </div>
            </form>
          </div>
          <div
            className={`flex flex-grow-1 justify-content-center mob-preview-container `}
            style={{ minHeight: 'fit-content' }}
          >
            <div className="relaive w-full flex justify-content-center">
              <div className="sticky top-4">
                <div className="flex flex-column justify-content-center align-items-center">
                  {selectedTemplate && (
                    // <div className="min-h-full">

                    <TemplatePreview
                      header={watch('header')}
                      footer={watch('footer')}
                      buttons={templateButtons}
                      content={watch('message')} // ✅ NO formatting
                      videoPreview={videoPreview}
                      documentPreview={documentPreview}
                      imagePreview={imagePreview}
                      file={file}
                    />
                    // </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
